// === APP Constants ===
export const APP_CONTACT = 'support@mail.careflai.com'
export const languages = [
  { code: 'fr', flag: '🇫🇷', name: 'Français' },
  { code: 'en', flag: '🇬🇧', name: 'English' },
]

// === USERS Constants ===
export const SEARCH_RADIUS_IN_METERS = 10000

// === SHARED DIAGNOSTIC Constants ===
export const sharedDiagnosticStatusColors = {
  in_process: 'green',
  closed: 'gray',
  expired: 'red',
}
export const receiverStatusColors = {
  pending: 'yellow',
  accepted: 'green',
  declined: 'red',
  expired: 'gray',
}

// === ANALYSIS Constants ===
// === MALARIA Constants ===
export const PARASITEMIA_THRESHOLD = 5
export const ANALYZED_CELLS_THRESHOLD = 10000

// Padding (in pixels) to add around malaria detection bounding boxes for display
// This makes boxes less tight around detected cells for better visibility
// Must match backend MALARIA_BBOX_PADDING in careflai-be/src/configs/constants.js
export const MALARIA_BBOX_PADDING = 4
